"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldContext = void 0;
var react_1 = require("react");
exports.FieldContext = react_1.createContext({
    isField: false,
});
